import React, { useContext } from "react";
import { Spin } from "antd";
import { PublicLayout } from "./PublicLayout";
import { Navigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { routes } from "../routes/routes";

interface Props {
  children: JSX.Element | JSX.Element[];
}
export const PublicRoute = ({ children }: Props) => {
  const { validateToken, isLoading } = useContext(AuthContext);

  // Mirror ProtectedRoute: don't decide based on validateToken() until the
  // async session-recovery on mount (AuthProvider.loadSession, which may
  // silently refresh from a valid cookie) has settled.
  if (isLoading) {
    return <Spin style={{ display: "flex", justifyContent: "center", marginTop: "20%" }} />;
  }

  if (validateToken()) {
    return <Navigate to={routes.dashboard} replace />;
  } else {
    return <PublicLayout>{children}</PublicLayout>;
  }
};
